import { render, staticRenderFns } from "./admin-aoi-list.vue?vue&type=template&id=5af81360&scoped=true&"
import script from "./admin-aoi-list.vue?vue&type=script&lang=js&"
export * from "./admin-aoi-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af81360",
  null
  
)

export default component.exports